import { Component, Input, Output, EventEmitter, OnInit, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from '../../shared/components/login/login.component'; // ajuste o path
import { AuthService } from '../../shared/services/apis/platform/auth.service';

@Component({
  selector: 'app-login-validation',
  template: '', // Não exibe nada na tela
  standalone: true,
})
export class LoginValidationComponent implements OnInit {
  @Output() loggedIn = new EventEmitter<boolean>();
  @Input() adminMenuPermission: number | null = null
  
  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.validateLogin();
  }

  validateLogin(): void {
    const token = this.authService.getToken();
    if (!token) {
      // Não logado: abre o modal e só emite true quando logar
      const dialogRef = this.dialog.open(LoginComponent, {
        disableClose: true, // obriga o login
        width: '400px',
      });

      dialogRef.afterClosed().subscribe(result => {
        // Recomendo: garantir que o AuthService atualizou o token
        if (this.authService.getToken()) {
          this.loggedIn.emit(true);
        } else {
          this.loggedIn.emit(false);
        }
      });
    } else {
      this.loggedIn.emit(true);
    }
  }
}